import React from 'react'
import PinLoginWrapper from 'redesign/pages/pin-login/pin-login-wrapper'
import TenantsPageContent from './TenantsPageContent'

const TenantsPage: React.FC = () => (
  <PinLoginWrapper>
    <TenantsPageContent />
  </PinLoginWrapper>
)

export default TenantsPage
